import React from "react";
import styles from "./styles.css";
import skeleton from "./skeleton.css";

const Skeleton = () => {

    return (
        <div styleName={"skeleton.carCard"}>
            <div className="shimmer" styleName={"skeleton.shimmerImgHeading"} />
            <div className="shimmer" styleName={"skeleton.shimmerImgContent"} />
            <div className="shimmer" styleName={"skeleton.shimmerImgHeading"} />
            <div className="shimmer" styleName={"skeleton.shimmerImgSubHeading"} />
            <div className="shimmer" styleName={"skeleton.shimmerImgSubHeading"} />
        </div>
    );
};

export default Skeleton;
